import PortalItem from '@arcgis/core/portal/PortalItem';
import IdentityManager from '@arcgis/core/identity/IdentityManager';
import Layer from '@arcgis/core/layers/Layer';
import { oauthPortal } from './arcGisPortal';

export type ArcGisAuthOptions =
  | { accessType: 'apiKey'; apiKey: string }
  | { accessType: 'userAuth'; portalUrl: string };
export async function createPortalItem({
  portalItemId,
  options,
}: {
  portalItemId: string;
  options: ArcGisAuthOptions;
}) {
  if (options.accessType === 'apiKey') {
    const portalItem = new PortalItem({
      id: portalItemId,
      apiKey: options.apiKey,
    });

    await portalItem.load();

    if (portalItem.url) {
      IdentityManager.registerToken({
        server: portalItem.url,
        token: options.apiKey,
      });
    }

    return portalItem;
  }

  return new PortalItem({
    id: portalItemId,
    portal: oauthPortal({
      authMode: 'immediate',
      url: options.portalUrl,
    }),
  });
}

export async function createServiceUrlLayer({
  serviceUrl,
  options,
}: {
  serviceUrl: string;
  options: ArcGisAuthOptions;
}) {
  if (options.accessType === 'apiKey') {
    IdentityManager.registerToken({
      server: serviceUrl,
      token: options.apiKey,
    });
  }

  const layer = await Layer.fromArcGISServerUrl({ url: serviceUrl });
  await layer.load();

  return layer;
}
